import {DxAppEvent} from "../../../dx-core/domain/events/dx-app-event";

export class DxCredentialsSubmittedEvent extends DxAppEvent {
  private _login: string;
  private _password: string;

  constructor(source: string, login, password, data?: any) {
    super(source, data);
    this._login = login;
    this._password = password;
  }

  get login(): string {
    return this._login;
  }

  set login(value: string) {
    this._login = value;
  }

  get password(): string {
    return this._password;
  }

  set password(value: string) {
    this._password = value;
  }
}
